import { z } from 'zod';

export const ICF_Base = z.object({
  requestId: z.string(),
  apiVersion: z.string().nullable(),
});
